/*
 *
 * Home reducer
 *
 */

import { fromJS } from "immutable"
import {
  GET_COMPANIES_FAILED,
  GET_COMPANIES_WATCHER,
  GET_COMPANIES_SUCCESS,
  GET_COMPANIES_INFO_SUCCESS,
  GET_COMPANIES_INFO_WATCHER,
  SEARCH_FAILED,
  SEARCH_SUCCESS,
  SEARCH_WATCHER,
} from "./constants"

export const initialState = fromJS({
  isLoading: false,
  companies: [],
  options: {
    sizes: [],
    collaborators: [],
    services: [],
    sectors: [],
    country: [],
  },
  searchLoading: false,
  searchResult: [],
})

function homeReducer(state = initialState, action) {
  switch (action.type) {
    case GET_COMPANIES_INFO_WATCHER:
      return state.set("options", {
        sizes: [],
        collaborators: [],
        services: [],
        sectors: [],
        country: [],
      })
    case GET_COMPANIES_INFO_SUCCESS:
      return state.set("options", action.payload)
    case GET_COMPANIES_WATCHER:
      return state.set("isLoading", true).set("companies", [])
    case GET_COMPANIES_SUCCESS:
      return state.set("isLoading", false).set("companies", action.payload)
    case SEARCH_WATCHER:
      return state.set("searchLoading", true).set("searchResult", [])
    case SEARCH_SUCCESS:
      return state
        .set("searchLoading", false)
        .set("searchResult", action.payload)
    case SEARCH_FAILED:
      return state.set("searchLoading", false).set("searchResult", [])
    default:
      return state
  }
}

export default homeReducer
